import { Injectable } from '@angular/core';
import { filter, map, Subject } from 'rxjs';

interface EventWrapper {
  eventType: string;
  payload?: any;
}

@Injectable()
export class EventBusService {
  private eventStream = new Subject<EventWrapper>();

  emit(eventType: string, payload?: any) {
    this.eventStream.next({ eventType, payload });
  }

  on(...eventTypes: string[]) {
    return this.eventStream.pipe(
      filter((x) => eventTypes.includes(x.eventType)),
      map((x) => x.payload)
    );
  }
}
